var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.95,
    height: 17.913,
    viewBox: "0 0 21.95 17.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M22.7,4.948a8.916,8.916,0,0,1-2.585.712,4.566,4.566,0,0,0,1.951-2.488,9.141,9.141,0,0,1-2.829,1.112,4.507,4.507,0,0,0-7.677,4.107,12.77,12.77,0,0,1-9.277-4.7,4.439,4.439,0,0,0-.615,2.234A4.507,4.507,0,0,0,3.677,9.7a4.614,4.614,0,0,1-2.039-.566v.049A4.507,4.507,0,0,0,5.247,13.6a4.634,4.634,0,0,1-2.039.127,4.5,4.5,0,0,0,4.2,3.122A9.014,9.014,0,0,1,1.823,18.8,9.756,9.756,0,0,1,.75,18.742a12.741,12.741,0,0,0,6.9,2.029A12.682,12.682,0,0,0,20.5,7.874V7.289A8.985,8.985,0,0,0,22.7,4.948Z",
    transform: "translate(-0.75 -2.859)",
    fill: "#63799b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c7fbed9966205b28d90cb3e17cffda7d.svg";
export { ForwardRef as ReactComponent };